import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import type { PlotGroup } from "@pdfking/renderer-api"

import { PlotMixin as mixin } from "../mixins/PlotMixin"
import { PlotShapes } from "./PlotShapes"

// A group is an SVG group: its children draw in their own coordinates and the
// browser composes the transforms, the same way nested XObjects compose in the
// PDF. Not to be confused with `PlotGroup`, the layout row of pages.
export const PlotShapeGroup = CreateRenderFunction({
  mixins: [mixin] as const,
  props: {
    action: {} as PlotGroup,
    media_count: 0,
  },
  render() {
    const [a, b, c, d, e, f] = this.action.matrix

    return (
      <g transform={`matrix(${a} ${b} ${c} ${d} ${this.to_px(e)} ${this.to_px(f)})`}>
        <PlotShapes
          context={this.context}
          media_click={this.media_click}
          media_count={this.media_count}
          printable={this.printable}
          request_media={this.request_media}
          shapes={this.action.shapes}
        />
      </g>
    )
  },
})
